import { Component, OnInit, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

export interface EditSektionData {
  id: string;
  name: string;
  gebaeudeId: string;
}

@Component({
  selector: 'app-edit-sektion-dialog',
  templateUrl: './edit-sektion-dialog.component.html',
  styleUrls: ['./edit-sektion-dialog.component.css'],
})
export class EditSektionDialogComponent implements OnInit {
  frmSektion: UntypedFormGroup;
  sektionId: string;
  gebaeudeId: string;

  constructor(
    public dialogRef: MatDialogRef<EditSektionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditSektionData,
    private _fb: UntypedFormBuilder
  ) {
    this.sektionId = data.id;
    this.gebaeudeId = data.gebaeudeId;

    this.frmSektion = this._fb.group({
      name: [data.name, [Validators.required, Validators.minLength(2)]],
      gebaeude_id: [this.gebaeudeId]
    });
  }

  ngOnInit() {
    // Form is already initialized in constructor
  }

  onConfirm(): void {
    if (this.frmSektion.valid) {
      this.dialogRef.close({ 
        event: 'update', 
        data: {
          id: this.sektionId,
          ...this.frmSektion.value
        }
      });
    }
  }

  onDelete(): void {
    const confirmed = confirm('Sind Sie sicher, dass Sie diese Sektion deaktivieren möchten? Sie wird als inaktiv markiert und in der Historie angezeigt.');
    if (confirmed) {
      this.dialogRef.close({ 
        event: 'delete', 
        data: { 
          id: this.sektionId,
          name: this.frmSektion.get('name')?.value || this.data.name
        }
      });
    }
  }

  onDismiss(): void {
    this.dialogRef.close({ event: 'cancel' });
  }
}

